import { Button, List, ListItem, Popover, Typography, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import { type FC, useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { FaultsDashboardsContext } from '../../contexts';

const StyledButton = styled(Button)(
  ({ theme }) => `
    background-color: ${theme.colors.avani.turc};
    border-radius: 8px;
    border: none;
    color: white;
    padding: 8px 12px;

    &:hover {
      border: none;
      color: ${theme.colors.avani.darkTitleText};

      .MuiSvgIcon-root {
        color: ${theme.colors.avani.darkTitleText};
      }
    }
`
);

const StyledListItem = styled(ListItem)(
  () => `
  cursor: pointer;
  display: flex;

  svg {
    margin-right: 12px;
  }
`
);

export const FaultVenueDropdown: FC = () => {
  const { setVenueName, venueNames, faults } = useContext(FaultsDashboardsContext);
  const theme = useTheme();
  const { visitFaultId } = useParams();

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const open = Boolean(anchorEl);
  const [buttonLabel, setButtonLabel] = useState<string>('Venue');

  useEffect(() => {
    const selectedFaultVenue = faults.find(({ id }) => id === visitFaultId)?.faultInteractions[0]?.venueName;
    if (selectedFaultVenue) {
      setButtonLabel(selectedFaultVenue);
      setVenueName(selectedFaultVenue);
    }
    //todo:v2-changes
  }, [faults]);

  return (
    <>
      <StyledButton
        variant="outlined"
        disabled={!venueNames.length}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        sx={{
          backgroundColor: 'white',
          border: `2px solid ${theme.colors.avani.magenta}`,
          color: theme.colors.avani.teal,
          paddingTop: '8px',
          borderRadius: '32px',
          marginLeft: '18px',
          [`&:hover`]: { border: `2px solid ${theme.colors.avani.magenta}`, color: theme.colors.avani.magenta }
        }}
      >
        {buttonLabel}
      </StyledButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'center', horizontal: 'left' }}
        onClose={() => setAnchorEl(null)}
      >
        <List>
          {!!venueNames.length && (
            <>
              {venueNames.length > 1 && (
                <StyledListItem
                  key={'all'}
                  value={'All'}
                  onClick={() => {
                    setVenueName(undefined);
                    setButtonLabel('Venue');
                    setAnchorEl(null);
                  }}
                >
                  <Typography sx={{ flexGrow: 1, pt: '3px' }}>All</Typography>
                </StyledListItem>
              )}
              {venueNames.map((option, index) => {
                return (
                  <StyledListItem
                    key={index}
                    value={option}
                    onClick={() => {
                      setVenueName(option);
                      setButtonLabel(option);
                      setAnchorEl(null);
                    }}
                  >
                    <Typography sx={{ flexGrow: 1, pt: '3px' }}>{option}</Typography>
                  </StyledListItem>
                );
              })}
            </>
          )}
        </List>
      </Popover>
    </>
  );
};
